import React, {useRef, useEffect, useState} from 'react'
import moment from 'moment';

const CardView = (props) => {
  const [showLeft, setShowLeft] = useState(false)
  const [showRight, setShowRight] = useState(false)

  const dateCards = useRef(null);

  const eventOperatings = props.getEventOperatings()
  useEffect(() => {
    setTimeout(
      () => {
        // Conta a quantidade de horas
        // eventOperatings.reduce -> soma os dias e horas
        const rulesCount = eventOperatings.reduce((sum, day) => sum + day.availableHours.length, 0)

        if (rulesCount === 1 && !props.hour.pk_schedule_rule) {
          const {setDate, setHour} = props
          const { date } = eventOperatings[0]
          const rule = eventOperatings[0].availableHours[0]
          setDate(moment(date).toDate());
          setHour({ name: rule.start, value: rule.start, pk_schedule_rule: rule.pk_schedule_rule })
        }
      }, 3000);
  }, [])
  //const rulesCount = props.eventOperatings.reduce((sum, day) => sum + day.availableHours.length, 0)

  return (
    <div className="event">
      <div className="title"> DATA E HORA</div>
      <div className="event-picker">
        {showLeft &&
        <div className="arrow left" onClick={() => {
          dateCards.current.scrollTo(dateCards.current.scrollLeft - dateCards.current.getBoundingClientRect().width, 0)
        }}>
          <span className="icon icon-chevron-left"/>
        </div>
        }

        <div ref={dateCards} className="event-cards">
          {eventOperatings.map(o =>
            o.availableHours.map(rule =>
              <div className="event-card" onClick={() => {
                props.setDate(moment(o.date));
                props.setHour({ name: rule.start, value: rule.start, pk_schedule_rule: rule.pk_schedule_rule })
              }}>
                <div className={"event-card-content " +
                (moment(props.date).format("YYYY-MM-DD") === moment(o.date).format("YYYY-MM-DD") && props.hour.pk_schedule_rule === rule.pk_schedule_rule && "active"
                )}>
                  <div className="date">
                    <div className="day">{moment(o.date).format("DD")}</div>
                    <div className="month">{moment(o.date).format("MMMM").substring(0, 3)}</div>
                  </div>

                  <div className="hour">
                    <div className="hour">{rule.start}</div>
                    <div className="vacancies"><small>{props.getIsDatePrivate(o.date, rule) ? 'Disponível' : `${props.getVacanciesInDate(o.date, rule)} vagas`}</small></div>
                  </div>

                </div>
              </div>
            ))}
        </div>

        <div className="arrow right" onClick={() => {
          dateCards.current.scrollTo(dateCards.current.scrollLeft + dateCards.current.getBoundingClientRect().width, 0);
          setShowLeft(true);
          props.handleGetMoreEventDates()
        }}>
          <span className="icon icon-chevron-right"/>
        </div>
      </div>
    </div>
  )
}

export default CardView
